import * as React from 'react';

type Props = {
    icon: React.ComponentType<any>;
    size: number;
};

export function NavbarIcon(props: Props) {
    const {icon: Icon, size} = props;

    return (
        <div className='nut-navbar-icon'>
            <Icon wrapWithDiv={false} size={size} />
        </div>
    );
}
